<template>
  <div>
    <h1>Manage Okta Federations</h1>
    <div class="mt-5">
      <federation-table v-if="!federationSsoGroups" :table-items="federations" @sso="getSso($event)" />
      <federation-groups-table v-if="federationSsoGroups" :table-items="federationSsoGroups" :user-groups="userGroups" :federation-id="federationId" @close="closeSso()" />
    </div>
  </div>
</template>

<script>
import FederationTable from '@/components/manageOktaFederations/FederationTable'
import FederationGroupsTable from '@/components/manageOktaFederations/FederationGroupsTable'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'manage-okta-federations',
  components: {
    FederationTable,
    FederationGroupsTable
  },
  data() {
    return {
      federationId: null
    }
  },
  computed: {
    ...mapState('oktaFederations', ['federations', 'federationSsoGroups']),
    ...mapState('manageUsers', ['userGroups'])
  },
  created() {
    this.getFederations()
    this.getUserGroups()
  },
  methods: {
    ...mapActions('oktaFederations', ['getFederations', 'getFederationSsoGroups']),
    ...mapActions('manageUsers', ['getUserGroups']),
    ...mapMutations('oktaFederations', ['setFederationSsoGroups']),
    getSso(federationId) {
      this.getFederationSsoGroups(federationId)
      this.federationId = federationId
    },
    closeSso() {
      this.setFederationSsoGroups(null)
    }
  }
}
</script>
